import React, { useState, useEffect } from "react";
import { useParams} from 'react-router-dom';
import axiosInstance from "../../../utils/axiosInstance";
import { Typography, Box, Button as MuiButton, CircularProgress, Alert} from '@mui/material';
import ListImproveAnswer from './ListImproveAnswer';
import { hasPermission }  from '../../../utils/permissionUtils';

export default function ImproveAnswer() {
  useEffect(() => {
    document.title = "Ground Truth | KlonIT Web Application";
  }, []);

  const [OriginalQuestion, setOriginalQuestion] = useState("");
  const [OriginalAnswer, setOriginalAnswer] = useState("");
  const [QuestionImprove, setQuestionImprove] = useState("");
  const [AnswerImprove, setAnswerImprove] = useState("");
  const [error, setError] = useState(null);
  const [dataRefresh, setDataRefresh] = useState(false);
  const { chatbotId : paramsChatbotId } = useParams();

  
  // Permission states
  const [canView, setCanView] = useState(false);
  const [canModify, setCanModify] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [checkingPermissions, setCheckingPermissions] = useState(true);


  // Check permissions
  useEffect(() => {
    const checkPermissions = async () => {
      setCheckingPermissions(true);
      try {
        const viewPerm = await hasPermission('answers-improvements', 'view');
        const modifyPerm = await hasPermission('answers-improvements', 'add|edit');
        const deletePerm = await hasPermission('answers-improvements', 'delete');

        setCanView(viewPerm);
        setCanModify(modifyPerm);
        setCanDelete(deletePerm);
      } catch (error) {
        console.error('Error checking permissions:', error);
        setCanView(false);
        setCanModify(false);
        setCanDelete(false);
      } finally {
        setCheckingPermissions(false);
      }
    };

    checkPermissions();
  }, []);

  const handleAddQuestionBtnClick = async () => {
    
    try {
      
      const params = paramsChatbotId ? { chatbot_id: paramsChatbotId } : {};

      const OriginalChatID = "user_chat_id";

      const data = {
        chat_id: OriginalChatID,
        question: OriginalQuestion,
        answer: OriginalAnswer,
        improve_question: QuestionImprove,
        improve_answer: AnswerImprove
      };

      await axiosInstance.post(`/add-improve-question`, data, {  params });

      // Clear the input after adding
      setOriginalQuestion("");
      setOriginalAnswer("");
      setAnswerImprove("");

      setError("Your improve answer has been added successfully.");

      setDataRefresh(true);

    } catch (error) {
        // console.error("Error adding question answer:", error);
        setError("Error adding question answer:", error);
    }
    
  };

  // Show loading state while checking permissions
  if (checkingPermissions) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
        <Typography>Checking permissions...</Typography>
      </Box>
    );
  }

  // Show access denied if no view permission
  if (!canView) {
    return (
      <div>
        <Alert severity="error" sx={{ mt: 6 }}>
          <strong>Access Denied</strong>
          <br />
          You don't have permission to view Language settings. Please contact your administrator.
        </Alert>
      </div>
    );
  }

  return (
    <ListImproveAnswer chatbotId={paramsChatbotId}  dataRefresh={dataRefresh} setDataRefresh={setDataRefresh} permission={{ 'canModify': canModify, 'canDelete':canDelete}} />
  );
}
